const KustomerChatEntry = () => {
  return <div id="kustomer-chat-entry"></div>;
};

export default KustomerChatEntry;
